import React, { useState, useEffect } from 'react';
import { Fab } from '@mui/material';
import logowhatsapp from 'assets/images/logo-whatsapp.png';
import { useToast } from 'legacyfrontend/hooks/useToast';
import ErrorSnackbar from 'legacyfrontend/components/ErrorSnackbar';

const FloatingButtonGroup = ({ phoneNumber }) => {
  const [isMounted, setIsMounted] = useState(false);
  const { toastState, hideToast } = useToast();

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const hasWhatsApp = Boolean(phoneNumber && phoneNumber !== null && phoneNumber !== undefined && phoneNumber.trim() !== '');
  
  // Solo mostrar el componente si hay WhatsApp y está montado
  if (!isMounted || !hasWhatsApp) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-[99999999]">
      <Fab
        component="a"
        href={`https://api.whatsapp.com/send/?phone=${phoneNumber}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contactar por WhatsApp"
        sx={{
          backgroundColor: '#25D366',
          transition: 'transform 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: '#25D366',
            transform: 'translateY(-4px)',
          }
        }}
      >
        <img 
          alt="Icono de WhatsApp" 
          src={logowhatsapp} 
          style={{ width: 32, height: 32 }} 
        />
      </Fab>

      <ErrorSnackbar
        open={toastState.open}
        message={toastState.message}
        severity={toastState.severity}
        onClose={hideToast}
      />
    </div>
  );
};

export default FloatingButtonGroup;
